<template>
  <div class="flex items-center cursor-pointer w-fit" @click="menuopen">
    <p class="text-skin-blue">Filtrar Cursos</p>
    <ChevronDown color="#F28062"/>
  </div>
</template>

<script>
import ChevronDown from './icons/ChevronDown.vue';
export default {
  components: {  ChevronDown },
    methods: {
    menuopen() {
      this.$store.commit("menuopen", true);
    },
  },
};

</script>
